import { createContext, Dispatch } from "react";
import { DataTableActions } from "./DataTableActions";
import { DataTableState, initialState } from "./DataTableState";

export const DataTableContext = createContext<{
    state: DataTableState;
    dispatch: Dispatch<DataTableActions>;
}>({
    state: initialState,
    dispatch: () => undefined,
});
